import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_RESET,
} from '../Constants/actionTypes';

import { forgotPasswordApi } from '../Constants/apiService';

export const resetForgotPassword = () => ({ type: FORGOT_PASSWORD_RESET });

export const sendForgotPassword = (email) => async (dispatch) => {
  dispatch({ type: FORGOT_PASSWORD_REQUEST });
  try {
    // API expects: { email }
    await forgotPasswordApi({ email });
    // Don’t leak if email exists: always success if request completes
    dispatch({ type: FORGOT_PASSWORD_SUCCESS });
  } catch (error) {
    // Still OK to surface a generic error (network/server down)
    const message =
      error.message === 'Failed to fetch' || error.message?.includes('NetworkError')
        ? 'Unable to reach server. Please try again later.'
        : 'Please try again in a moment.';
    dispatch({ type: FORGOT_PASSWORD_FAILURE, payload: message });
  }
};
